import { WarningNotice } from "web_myplann/Goals/Components/AmountSections/WarningNotice";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { formatNumber } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	excess: number;
	currencySuffix: string;
};

export const OverpaidNotice: React.FC<Props> = ({ excess, currencySuffix }) => {
	const { t } = useResource();

	return (
		<WarningNotice
			title={t(Resources.Goals.Form.Notices.overpaidTitle)}
			description={t(Resources.Goals.Form.Notices.overpaidDescription, {
				excess: `${formatNumber(excess)} ${currencySuffix}`,
			})}
		/>
	);
};
